export const imageOne =
  "https://cdn.pixabay.com/photo/2018/08/09/10/46/telephone-3594206_960_720.jpg";

export const imageTwo =
  "https://cdn.pixabay.com/photo/2016/11/21/12/10/tv-1844964_960_720.jpg";

export const imageThree =
  "https://cdn.pixabay.com/photo/2021/11/25/19/50/tape-6824489_960_720.jpg";

export const imageFour =
  "https://cdn.pixabay.com/photo/2016/03/10/09/24/typewriter-1248088_960_720.jpg";

export const imageFive =
  "https://cdn.pixabay.com/photo/2018/08/22/10/11/radio-3623299_960_720.jpg";

export const imageSix =
  "https://images.unsplash.com/photo-1554921027-b91f0beeb07d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80";
